import { render, staticRenderFns } from "./BaseConfirm.vue?vue&type=template&id=6b5424f8&scoped=true&"
import script from "./BaseConfirm.vue?vue&type=script&lang=js&"
export * from "./BaseConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfirm.vue?vue&type=style&index=0&id=6b5424f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5424f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDialog})
